import React from 'react'
import ReactDOM from 'react-dom'
import SharedSortableLists from './SharedSortableLists'
import CsrPublicationJobsIndex from './CsrPublicationJobsIndex'

class CsrSortablePublicationJobsList extends SharedSortableLists {
  sortMapping() {
    return {
      publisher: "area_director_name",
      publication: "publication_name",
      deadline: "deadline_day",
      date_modified: "formatted_modified_at",
    };
  }

  defaultSortKey() {
    return "publisher"
  }

  renderList(sorted) {
    $(`.js-sort-${this.sortScope.split('-')[2]}-count`).text(`(${sorted.length})`)
    ReactDOM.render(<CsrPublicationJobsIndex data={sorted} />, $(this._container)[0])
  }

  sortData() {
    let sortAttr = this.sortMapping()[this.sortKey];
    switch (this.sortKey) {
      case "publisher":
      case "publication":
      case "date_modified":
        return this.sortBy({attr: sortAttr});
        break;

      case "deadline":
        return this.sortBy({attr: sortAttr, reverse: true})
        break;

      default:
        return this.sortBy({attr: 'id'});
    }
  }

  updateData(key, newData) {
    this.data = newData;
    this.render();
  }
}

export default CsrSortablePublicationJobsList
